module.exports = __webpack_public_path__ + "0a0f5caf5d5ed36c4a09a27c5ed9039b.pdf";